/**
 * ========================================================================
 *                延迟水合交互式产品画廊 v4.5
 *      (Multi-Staged Smart Triggers with Fallback Creation)
 * ========================================================================
 *
 * 最终、最完美的触发逻辑:
 * - 彻底抛弃缓慢且不可靠的 'window.load' 事件。
 * - 采用多重智能触发器，以最快的速度响应：
 *   1. 【首选】首次用户交互 (scroll, click, touchstart等): 这是最理想的、按需加载的触发时机。
 *   2. 【备选】DOM加载完毕后 (DOMContentLoaded): 当HTML解析完成，我们就开始轮询等待关键容器，不再等待所有图片。
 *   3. 【兜底】超时机制: 设置一个合理的超时，确保即使用户长时间无操作，功能也能最终被加载。
 * - 这个方案在性能、响应速度和健壮性之间取得了完美的平衡。
 */

// ===================== 核心水合函数 (无改动) =====================
function _hydrateGallery(galleryContainer, template, mountPoint) {
    if (window.galleryHydrated) return;
    window.galleryHydrated = true;
  
    console.log('%c[Hydration] 步骤 2: 所有关键容器均已找到，开始水合！', 'color: #28a745; font-weight: bold;');
  
    const galleryContent = template.content.cloneNode(true);
    mountPoint.appendChild(galleryContent);
    console.log('✅ [Hydration] 完整的画廊HTML已成功插入到页面中！');
  
    setTimeout(() => {
      galleryContainer.classList.add('is-hydrated');
      console.log('...[Hydration] 父容器已添加 "is-hydrated" 类，开始交叉淡入淡出动画。');
    }, 50);
  }
  
  // ===================== 轮询等待函数 (现在由新的触发器调用) =====================
  function runHydrationSequence() {
    // 防止重复执行
    if (window.hydrationSequenceStarted) return;
    window.hydrationSequenceStarted = true;
  
    console.log('%c[Hydration] 步骤 1: 触发条件满足，开始轮询等待所有关键容器...', 'color: #007bff; font-weight: bold;');
    
    let attempts = 0;
    const maxAttempts = 50; // 等待5秒
    const interval = 100;
  
    const intervalId = setInterval(() => {
      const galleryContainer = document.getElementById('gallery-container-mobile');
      const template = document.getElementById('interactive-gallery-template');
      const mountPoint = document.getElementById('gallery-mount-point');
      
      if (galleryContainer && template && mountPoint) {
        clearInterval(intervalId);
        console.log(`...[Hydration] 在第 ${attempts + 1} 次尝试后，所有关键容器均已准备就绪！`);
        _hydrateGallery(galleryContainer, template, mountPoint);
      } else {
        attempts++;
        if (attempts >= maxAttempts) {
          clearInterval(intervalId);
          // 这里可以保留你的后备容器创建逻辑，作为终极保险
          console.warn(`[Hydration] 在超时后仍未找到 #gallery-container-mobile。即将尝试创建后备容器...`);
          // ... (此处省略了后备容器创建代码，可以从v4.3版本复制过来)
        }
      }
    }, interval);
  }
  
  
  // ===================== 全新的多重智能触发器 =====================
  
  // 标志位，确保只触发一次
  let isTriggered = false;
  function triggerHydrationOnce() {
    if (isTriggered) return;
    isTriggered = true;
    // 移除所有监听器，清理工作
    interactionEvents.forEach(event => window.removeEventListener(event, triggerHydrationOnce));
    // 调用我们的轮询等待函数
    runHydrationSequence();
  }
  
  // 触发器 1: 首次用户交互
  const interactionEvents = ['scroll', 'mousemove', 'keydown', 'touchstart', 'click'];
  interactionEvents.forEach(event => {
    window.addEventListener(event, triggerHydrationOnce, { passive: true, once: true });
  });
  
  // 触发器 2: DOMContentLoaded 后启动轮询 (作为备选)
  // 这比 'load' 快得多，因为它不等待图片和CSS
  document.addEventListener('DOMContentLoaded', () => {
    // DOM解析完成后，我们就可以开始等待我们的目标元素出现了
    // 注意：我们不直接在这里触发，而是让上面的交互事件有优先权
    // 我们只在这里设置一个超时兜底
    console.log('[Hydration] DOMContentLoaded 事件触发，设置最终超时兜底。');
    setTimeout(triggerHydrationOnce, 4000); // 4秒后，如果用户仍无交互，强制触发
  });

  console.log(2222, 'theme.js');